export const RegistrationReducer = (state, action) => {
  switch (action.type) {
    case "IS_ERROR_ACTIVE":
      return {
        ...state,
        isError: true,
        isErrorMessage: action.message
      };
    case "IS_ERROR_REMOVED":
      return {
        ...state,
        isError: false,
        isErrorMessage: []
      };
    default:
      return state;
  }
};
